import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { FOOTER, CLIENT_DASHBOARD } from '../constants/testIds';
import { EXPORT_PAGES } from '../lib/pageContent';
import { CountryFlag } from './CountryFlag';

const LINKS = [
  { label: 'Quality Tiers', href: '/#quality-tiers' },
  { label: 'Bulk Order', href: '/#order-form' },
  { label: 'Services', to: '/services' },
  { label: 'International Shipping', to: '/international-shipping' },
  { label: 'Quality Grades', to: '/quality-grades' },
  { label: 'Testimonials', to: '/testimonials' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Blog', to: '/blog' },
  { label: 'Contact', href: '/#contact' },
  { label: 'Client Login', to: '/login', testId: CLIENT_DASHBOARD.footerNavLink },
  { label: 'Admin Login', to: '/admin/login', testId: 'footer-admin-login-link' },
];

export const Footer = () => (
  <footer data-testid={FOOTER.section} className="bg-brand-bg border-t border-brand-border/60 py-12">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
      <div>
        <Logo />
        <p className="mt-4 text-brand-muted text-sm max-w-xs">
          An international brand — wholesale bulk used tires, graded and shipped worldwide.
        </p>
      </div>

      <nav className="flex flex-wrap gap-6 font-mono text-xs uppercase tracking-wider text-brand-muted">
        {LINKS.map((l) =>
          l.to ? (
            <Link key={l.to} to={l.to} data-testid={l.testId} className="hover:text-brand-orange transition-colors">
              {l.label}
            </Link>
          ) : (
            <a key={l.href} href={l.href} className="hover:text-brand-orange transition-colors">
              {l.label}
            </a>
          )
        )}
      </nav>

      <p className="font-mono text-xs text-brand-muted">
        © {new Date().getFullYear()} BulkUsedTires.com — All Rights Reserved.
      </p>
    </div>

    <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-8 pt-8 border-t border-brand-border/40">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-3">
        <p className="font-mono text-xs uppercase tracking-widest text-brand-muted">Export Markets We Serve</p>
        <Link to="/export" className="font-mono text-xs uppercase tracking-widest text-brand-amber hover:text-brand-orange transition-colors">
          View All Export Destinations →
        </Link>
      </div>
      <nav className="flex flex-wrap gap-5 font-mono text-xs uppercase tracking-wider text-brand-muted">
        {EXPORT_PAGES.filter((p) => !p.draft).map((p) => (
          <Link key={p.slug} to={`/export/${p.slug}`} className="inline-flex items-center gap-1.5 hover:text-brand-orange transition-colors">
            <CountryFlag code={p.countryCode} />
            {p.navLabel}
          </Link>
        ))}
      </nav>
    </div>
  </footer>
);
